import { useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { AuthModal } from "./components/AuthModal";
import { NavBar } from "./components/NavBar";
import { useAuth } from "./context/AuthContext";
import { FeedPage } from "./features/feed/FeedPage";
import { LeaderboardPage } from "./features/leaderboard/LeaderboardPage";
import { MapPage } from "./features/map/MapPage";
import { ProfilePage } from "./features/profile/ProfilePage";

function ProfileRedirect({ onAuthClick }: { onAuthClick: () => void }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) {
    onAuthClick();
    return <Navigate to="/map" replace />;
  }
  return <Navigate to={`/@${user.handle}`} replace />;
}

export function AppRouter() {
  const [showAuth, setShowAuth] = useState(false);

  return (
    <div className="app-shell">
      <NavBar onAuthClick={() => setShowAuth(true)} />

      <Routes>
        <Route path="/map" element={<MapPage onSignInPrompt={() => setShowAuth(true)} />} />
        <Route path="/buzz" element={<FeedPage onSignInPrompt={() => setShowAuth(true)} />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/profile" element={<ProfileRedirect onAuthClick={() => setShowAuth(true)} />} />
        <Route path="/@:handle" element={<ProfilePage />} />
        <Route path="*" element={<Navigate to="/map" replace />} />
      </Routes>

      {showAuth && <AuthModal onClose={() => setShowAuth(false)} />}
    </div>
  );
}
